<template>
  <v-container
    v-resize="onResize"
    :class="isLargeScreen? 'paper': 'article'"
    :style="{height: height}"
  >
    <div class="lines">
      <div
        class="text"
        :contenteditable="isLargeScreen"
        spellcheck="false"
      >
        {{ msg }}
      </div>
      <template v-if="isLargeScreen">
        <div class="holes hole-top" />
        <div class="holes hole-middle" />
        <div class="holes hole-bottom" />
      </template>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'NotebookVue',
  props: {
    msg: {
      type: String,
      default: '-',
    },
    isLargeScreen: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      height: '500px',
    };
  },
  methods: {
    onResize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          this.height = `${window.innerHeight}px`;
          break;
        case 'md':
        case 'lg':
        case 'xl':
        default:
          this.height = `${window.innerHeight - 80}px`;
      }
    },
  },
};
</script>

<style scoped>
  @import url(https://fonts.font.im/css?family=Bad+Script);
  body {
    margin: 0;
    padding: 0;
    background: lightgoldenrodyellow;
  }
  .article  .text{
    text-indent: 2em;
    margin-bottom: 16px;
    text-align: justify;
  }
  .paper {
    position: absolute;
    width: 100%;
    background: rgba(255,255,255,0.9);
    margin: -275px -225px 0 0;
    left: 2%;
    top: 280px;
    box-shadow: 0px 0px 5px 0px #888;
  }
  .paper::before {
    content: '';
    position: absolute;
    left: 45px;
    height: 100%;
    width: 2px;
    margin-top: -24px;
    background: rgba(255,0,0,0.4);
  }
  .paper .lines {
    margin-top: 0px;
    height: calc(100% - 40px);
    width: 100%;
    background-image: repeating-linear-gradient(white 0px, white 24px, steelblue 25px);
  }
  .paper .text {
    position: absolute;
    top: 65px;
    left: 55px;
    bottom: 10px;
    right: 10px;
    line-height: 2em;
    color: #000;
    font-size: 2em;
    font-family: 'Bad Script';
    overflow: hidden;
    overflow-y: auto;
    outline: none;
  }
  .paper .holes {
    position: absolute;
    left: 10px;
    height: 25px;
    width: 25px;
    background: lightgoldenrodyellow;
    border-radius: 50%;
    box-shadow: inset 0px 0px 2px 0px #888;
  }
  .paper .hole-top {
    top: 10%;
  }
  .paper .hole-middle {
    top: 50%;
  }
  .paper .hole-bottom {
    bottom: 10%;
  }
</style>
